"use client";
import Image from "next/image";
import { useRouter } from "next/navigation";
import { useEffect, useState } from "react";
import {
  CADASTRO_SESSION_EVENT,
  hasCadastroSession,
} from "@/services/cadastroSession";

export default function RegisterHome() {
  const router = useRouter();
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    const syncSession = () => {
      setIsLoggedIn(hasCadastroSession());
    };

    const handleStorageChange = (event: StorageEvent) => {
      if (
        event.key &&
        event.key !== "cazeemail" &&
        event.key !== "cazeprofile" &&
        event.key !== "cazename"
      ) {
        return;
      }

      syncSession();
    };

    syncSession();
    window.addEventListener("storage", handleStorageChange);
    window.addEventListener(CADASTRO_SESSION_EVENT, syncSession);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
      window.removeEventListener(CADASTRO_SESSION_EVENT, syncSession);
    };
  }, []);

  if (isLoggedIn) {
    return null;
  }

  return (
    <section
      className="faq-section reveal-up"
      style={{
        backgroundColor: "#fec822",
        height: 264,
        display: "flex",
        justifyContent: "center",
      }}
    >
      <div className="">
        <div className="flex flex-col justify-center items-center">
          <h1
            className="font-extrabold text-[#2033ef] text-[26px] -mt-5 mb-3 uppercase text-center w-[300px]"
            style={{
              lineHeight: 1,
            }}
          >
            cadastre-se
            <br /> para participar
          </h1>
          <span className="text-center lg:max-w-120 w-[95%] text-black font-medium text-wrap ">
            Com o cadastro, você pode entrar nas filas virtuais das experiências
            e participar das dinâmicas interativas do palco junto com o público.
          </span>

          <Image
            src="/images/register.svg"
            height={40}
            width={200}
            alt="Ticket"
            priority
            className="mt-4 cursor-pointer"
            onClick={() => router.push("/cadastro")}
          />
        </div>
      </div>

      <style jsx>{`
        .faq-section {
          background: #fff;
          padding: 4rem 0 5rem;
          scroll-margin-top: 6.5rem;
        }

        .faq-shell {
          display: grid;
          gap: 2rem;
        }

        .faq-heading {
          display: grid;
          gap: 1.25rem;
        }

        .faq-badge {
          display: inline-flex;
          width: fit-content;
          align-items: center;
          gap: 0.75rem;
          border: 1px solid #fec822;
          color: #fec822;
          padding: 0.9rem 1.1rem;
          font-size: 0.72rem;
          font-weight: 900;
          text-transform: uppercase;
          letter-spacing: 0.06em;
        }

        .faq-badge-dot {
          width: 0.5rem;
          height: 0.5rem;
          border-radius: 999px;
          background: #fec822;
        }

        .faq-title-row {
          display: flex;
          align-items: center;
          gap: 1rem;
        }

        .faq-region-title {
          color: #fec822;
          font-size: clamp(2rem, 4vw, 3.25rem);
          font-weight: 950;
          line-height: 0.96;
          text-transform: uppercase;
        }

        .faq-region-subtitle {
          margin-top: 0.5rem;
          color: rgba(255, 255, 255, 0.86);
          font-size: 0.95rem;
          font-weight: 700;
          text-transform: uppercase;
          letter-spacing: 0.08em;
        }

        .faq-filters {
          display: flex;
          flex-wrap: wrap;
          gap: 0.75rem;
        }

        .faq-filter {
          min-width: 92px;
          border: 1px solid #2033ef;
          border-radius: 999px;
          background: transparent;
          color: #2033ef;
          padding: 0.85rem 1.2rem;
          font-size: 0.95rem;
          font-weight: 900;
          cursor: pointer;
        }

        .faq-filter.is-active {
          background: #fec822;
          border-color: #fec822;
          color: #2033ef;
        }

        .faq-sections {
          display: grid;
          gap: 1.5rem;
        }

        .faq-section-block {
          display: grid;
          gap: 0.85rem;
        }

        .faq-section-label {
          color: #2033ef;
          font-size: 0.95rem;
          font-weight: 900;
          text-transform: uppercase;
          letter-spacing: 0.1em;
        }

        .faq-list {
          display: grid;
          gap: 0.9rem;
        }

        .faq-item {
          border: 1px solid rgba(255, 255, 255, 0.18);
          border-radius: 24px;
          background: rgba(255, 255, 255, 0.08);
          overflow: hidden;
          backdrop-filter: blur(10px);
        }

        .faq-item.is-open {
          background: white;
          border-color: white;
          color: #fff;
        }

        .faq-question {
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 1rem;
          border: 0;
          background: #2033ef;
          color: inherit;
          padding: 1.25rem 1.35rem;
          text-align: left;
          font-size: 1rem;
          font-weight: 800;
          cursor: pointer;
        }

        .faq-icon {
          flex-shrink: 0;
          width: 2rem;
          height: 2rem;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          border-radius: 999px;
          background: #fec822;
          color: #2033ef;
          font-size: 1.4rem;
          line-height: 1;
        }

        .faq-answer {
          padding: 0 1.35rem 1.35rem;
          display: grid;
          gap: 0.85rem;
          color: #fff;
          font-size: 0.96rem;
          line-height: 1.6;
          background: #2033ef;
        }

        @media (max-width: 768px) {
          .faq-section {
            padding: 3rem 0 4rem;
          }

          .faq-title-row {
            align-items: flex-start;
          }

          .faq-question {
            padding: 1.05rem 1.1rem;
            font-size: 0.95rem;
          }

          .faq-answer {
            padding: 0 1.1rem 1.1rem;
            font-size: 0.92rem;
          }
        }
      `}</style>
    </section>
  );
}
